import { render } from "./ProjectUploadProgress.vue?vue&type=template&id=21f34f9c"
import script from "./ProjectUploadProgress.vue?vue&type=script&lang=js"
export * from "./ProjectUploadProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__